import { StandardEvents } from '@shopify/events';

const controllers = new Map();

function mount(marker) {
  const section = marker.closest('.shopify-section');
  const form = section?.querySelector('product-form-component');
  if (!form || controllers.has(section)) return;
  const abort = new AbortController();
  const { signal } = abort;
  let pending = false;
  let selecting = false;
  let variantRequest = 0;
  let locked = false;
  let disabled = [];
  let purchaseDisabled = form.querySelector('[name="add"]')?.disabled ?? true;
  const status = document.createElement('p');
  status.className = 'n4-pdp-order-status';
  status.setAttribute('role', 'status');
  form.after(status);
  const setLocked = value => {
    if (locked === value) {
      if (value) {
        const button = form.querySelector('[name="add"]');
        if (button) button.disabled = true;
      }
      return;
    }
    locked = value;
    form.setAttribute('aria-busy', String(value));
    const button = form.querySelector('[name="add"]');
    button?.setAttribute('aria-busy', String(value));
    if (value) {
      disabled = [...form.querySelectorAll('button, input:not([type="hidden"]), select'), ...section.querySelectorAll('variant-picker input, variant-picker select, variant-picker button')].filter(control => !control.disabled);
      disabled.forEach(control => { control.disabled = true; });
    } else {
      disabled.forEach(control => { if (control.isConnected) control.disabled = false; });
      disabled = [];
      const currentButton = form.querySelector('[name="add"]');
      if (currentButton) currentButton.disabled = purchaseDisabled;
      form.querySelector('quantity-selector-component')?.updateButtonStates?.();
    }
  };
  section.addEventListener('submit', event => {
    if ((!pending && !selecting) || !form.contains(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, { capture: true, signal });
  section.addEventListener(StandardEvents.cartLinesUpdate, event => {
    if (event.target !== form || event.action !== 'add' || !event.promise || pending) return;
    status.textContent = '';
    pending = true;
    if (!locked) purchaseDisabled = form.querySelector('[name="add"]')?.disabled ?? true;
    setLocked(true);
    event.promise.catch(() => {
      if (!signal.aborted) status.textContent = marker.dataset.error;
    }).finally(() => {
      if (!signal.aborted) {
        pending = false;
        setLocked(selecting);
      }
    });
  }, { signal });
  section.addEventListener(StandardEvents.productSelect, event => {
    if (event.target.closest?.('product-card') || !event.promise) return;
    const request = ++variantRequest;
    if (!locked) purchaseDisabled = form.querySelector('[name="add"]')?.disabled ?? true;
    selecting = true;
    setLocked(true);
    event.promise.then(({ detail }) => {
      if (signal.aborted || request !== variantRequest) return;
      if (detail?.productId && String(detail.productId) !== form.dataset.productId) return;
      const updatedForm = detail?.html?.querySelector(`product-form-component[data-product-id="${form.dataset.productId}"]`);
      const updatedButton = updatedForm?.querySelector('[name="add"]');
      if (updatedButton) purchaseDisabled = updatedButton.disabled;
      else if (detail?.resource === null || detail?.resource?.available === false) purchaseDisabled = true;
    }).catch(() => {}).finally(() => {
      if (signal.aborted || request !== variantRequest) return;
      selecting = false;
      setLocked(pending);
    });
  }, { signal });
  controllers.set(section, { abort, status, release: () => setLocked(false) });
}

function cleanup(root) {
  for (const [section, controller] of controllers) {
    if (!section.isConnected || root === section || root?.contains?.(section)) {
      controller.abort.abort();
      controller.release();
      controller.status.remove();
      controllers.delete(section);
    }
  }
}

function init(root) {
  cleanup();
  root.querySelectorAll('[data-n4-purchase-guard]').forEach(mount);
}

init(document);
document.addEventListener('shopify:section:load', event => init(event.target));
document.addEventListener('shopify:section:unload', event => cleanup(event.target));
